import AppleLogin from "react-apple-login";
import { useRecoilValue } from "recoil";
import LoginButtonTemplateV3 from "./LoginButtonTemplateV3";
import { userSimpleAtom } from "recoil/userSimpleAtom";
import { useState } from "react";
import { isDev } from "../../../config";
import useAutoLoginV3 from "./useAutoLoginV3";

export default function AppleLoginButtonV3({
  render,
}: {
  render?: (props: {
    onClick: (e?: any) => void;
    disabled?: boolean;
  }) => JSX.Element;
}) {
  useAutoLoginV3();
  const user = useRecoilValue(userSimpleAtom);
  const [idToken, setIdToken] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);

  const apple_cliendId = isDev
    ? "dev.orwellhealth.distancing.login"
    : "com.orwellhealth.distancing.login";

  const apple_redirectUrl = isDev
    ? "https://dev-www.distancing.im/v3/oauth/apple"
    : `${window.location.origin}/v3/oauth/apple`;

  return (
    <AppleLogin
      clientId={apple_cliendId}
      redirectURI={apple_redirectUrl}
      responseType="code id_token"
      responseMode="fragment"
      callback={(response: any) => {
        if (response?.authorization?.id_token) {
          setIdToken(response.authorization.id_token);
        }
        setIsLoading(false);
      }}
      render={
        render
          ? render
          : (props) => (
              <LoginButtonTemplateV3
                loginType="apple"
                action={() => {
                  setIsLoading(true);
                  props.onClick();
                }}
                isLoggedIn={!!user?.accessToken}
                isLoading={isLoading}
              />
            )
      }
    />
  );
}
